import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import config from './common/config'
import common from './common/common.js'
// import 'iview/dist/styles/iview.css'
import 'view-design/dist/styles/iview.css';

import deleteModel from './views/common/deleteModel.vue'

import { List,ListItem,Button, Table, Switch, Card, Collapse, Cell, Menu, Dropdown,
  Page, Steps, Input, Radio, Checkbox, Select, DatePicker,Progress,
   TimePicker, Cascader, ColorPicker, Form, Message, Modal, Tree,
    Tooltip, Poptip, Avatar, Spin,
    FormItem, Sider, Layout, DropdownMenu, DropdownItem,InputNumber,
     Tabs, TabPane, Upload, Icon, Row, RadioGroup, MenuItem, Submenu,Transfer,
     Step, Breadcrumb, BreadcrumbItem, CheckboxGroup, Timeline, Header, Option, Col, TimelineItem, Panel, Notice} from 'view-design';
Vue.component('Transfer', Transfer);
Vue.component('Button', Button);
Vue.component('Table', Table);
Vue.component('Card', Card);
Vue.component('Collapse', Collapse);
Vue.component('List', List);
Vue.component('ListItem', ListItem);
Vue.component('Cell', Cell);
Vue.component('Menu', Menu);
Vue.component('Dropdown', Dropdown);
Vue.component('Page', Page);
Vue.component('Steps', Steps);
Vue.component('Input', Input);
Vue.component('InputNumber', InputNumber);
Vue.component('Progress', Progress);
Vue.component('i-Switch', Switch);
Vue.component('Radio', Radio);
Vue.component('Checkbox', Checkbox);
Vue.component('Select', Select);
Vue.component('DatePicker', DatePicker);
Vue.component('TimePicker', TimePicker);
Vue.component('Cascader', Cascader);
Vue.component('ColorPicker', ColorPicker);
Vue.component('Form', Form);
Vue.component('Message', Message);
Vue.component('Modal', Modal);
Vue.component('Tree', Tree);
Vue.component('Tooltip', Tooltip);
Vue.component('Poptip', Poptip);
Vue.component('Avatar', Avatar);
Vue.component('Spin', Spin);
Vue.component('FormItem', FormItem);
Vue.component('Sider', Sider);
Vue.component('Layout', Layout);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Upload', Upload);
Vue.component('Icon', Icon);
Vue.component('Row', Row);
Vue.component('RadioGroup', RadioGroup);
Vue.component('MenuItem', MenuItem);
Vue.component('Submenu', Submenu);
Vue.component('Step', Step);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Timeline', Timeline);
Vue.component('Header', Header);
Vue.component('Option', Option);
Vue.component('Col', Col);
Vue.component('TimelineItem', TimelineItem);
Vue.component('Panel', Panel);
Vue.component('Notice', Notice);

import vueCropper from "vue-cropper"

Vue.use(vueCropper)

Vue.prototype.$Modal = Modal;
Vue.prototype.$Notice = Notice;
Vue.prototype.$Message = Message;
// import { HotTable } from '@handsontable-pro/vue'
// import '../node_modules/handsontable-pro/dist/handsontable.full.css';
// import '../../node_modules/_handsontable-pro@6.2.3@handsontable-pro/dist/handsontable.full.css';
// import './resourse/handsontable.full.css';
// import '@handsontable-pro/vue';
// import Handsontable from 'handsontable-pro'
// Vue.component('HotTable', HotTable);

// import iView from 'iview'
// Vue.use(iView);
Vue.use(deleteModel);
Vue.config.productionTip = false;
Vue.prototype.config = config;
Vue.prototype.axios = axios;

import Print from 'vue-print-nb'
Vue.use(Print);

import Distpicker from 'v-distpicker'
Vue.component('v-distpicker', Distpicker)
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'


Vue.prototype.transPrice = common.transPrice; //金额转换   199 ==> 1.99

var option = {
    maxSpreadZoom: 2, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
   fullscreenEl: true, //控制是否显示右上角全屏按钮
    closeEl: true, //控制是否显示右上角关闭按钮
    tapToClose: true, //点击滑动区域应关闭图库
    shareEl: true, //控制是否显示分享按钮
    zoomEl: true, //控制是否显示放大缩小按钮
    counterEl: true, //控制是否显示左上角图片数量按钮
    arrowEl: true,  //控制如图的左右箭头（pc浏览器模拟手机时）
    tapToToggleControls: true, //点击应切换控件的可见性
    clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
  }
Vue.use(preview,option)


import ImageViewer from 'vue2-viewer';
Vue.use(ImageViewer);

import SearchModelNew from '@/views/common/searchModelNew'
Vue.use(SearchModelNew);
Vue.component('SearchModelNew', SearchModelNew)

import SearchModel from '@/views/common/searchModel'
Vue.use(SearchModel);
Vue.component('SearchModel', SearchModel)
import EleInput from '@/views/common/eleInput'
Vue.use(EleInput);
Vue.component('EleInput', EleInput)
    // 请求的拦截器
   axios.interceptors.request.use(function (config) {
    let tokenP = new Promise((r,e)=>{
      return r(common.getToken())
    })

    tokenP.then((token)=>{
      if(token === false && window.nowUrlName != 'login' && window.nowUrlName != 'retrievePwd'){
        router.push({name:'login'});
      }

      // 判断请求的类型
      // 如果是post请求就把默认参数拼到data里面
      // 如果是get请求就拼到params里面

      if(config.method === 'post'&& !(config.data instanceof FormData) && window.nowUrlName != 'login') {
        let data = config.data
        config.data = {
            token: token,
            ...data
        }
      } else if(config.method === 'get' && window.nowUrlName != 'login') {
          config.params = {
              token: token,
              ...config.params
          }
      }else if(config.method === 'delete' && window.nowUrlName != 'login'){
        config.params = {
            token: token,
            ...config.params
        }
      }else if(config.method === 'patch' && window.nowUrlName != 'login'){
        let data = config.data
        config.data = {
            token: token,
            ...data
        }
      }
      return config;

    })

    return config;


    }, function (error) {
      return Promise.reject(error);
    })

    axios.interceptors.response.use((response) => {
        if(response.data.code == 401){
            window.sessionStorage.clear(); //清空缓存
            router.push({ name: 'login' })
        }

        return response;
    }, (error) => {
        // window.sessionStorage.clear(); //清空缓存
        // router.push({ name: 'login' })
        common.msg("error", "error", () => {});
        return Promise.reject(error)
    })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
